"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rpcFeedsCatalog = void 0;
exports.rpcFeedsCatalog = [
    {
        name: 'sAVAX/AVAX Exchange Rate',
        decimals: 18,
        chainAlias: 'avalanche',
        returnType: 'type-0',
        contractAddress: '0x2b2C81e08f1Af8835a78Bb2A90AE924ACE0eA4bE',
        implementationAddress: '0x0CE7F620Eb645a4FbF688a1C1937bC6CB0CbDd29',
        contractMethods: ['getPooledAvaxByShares'],
        contractMethodsParameters: [['1000000000000000000']],
        callData: ['0x4a36d6c10000000000000000000000000000000000000000000000000de0b6b3a7640000']
    },
    {
        name: 'BNBx/BNB Exchange Rate',
        decimals: 18,
        chainAlias: 'bsc',
        returnType: 'type-0',
        contractAddress: '0x3b961e83400D51e6E1AF5c450d3C7d7b80588d28',
        implementationAddress: '0x8de709A6A1A4FD41516C4C92e6B011e69331fDD3',
        contractMethods: ['convertBnbXToBnb'],
        contractMethodsParameters: [['1000000000000000000']],
        callData: ['0xca0506e80000000000000000000000000000000000000000000000000de0b6b3a7640000']
    },
    {
        name: 'slisBNB/BNB Exchange Rate',
        decimals: 18,
        chainAlias: 'bsc',
        returnType: 'type-0',
        contractAddress: '0x1adB950d8bB3dA4bE104211D5AB038628e477fE6',
        implementationAddress: '0x4D9eD586A8490d227dAfDBe520306fbae7a33430',
        contractMethods: ['convertSnBnbToBnb'],
        contractMethodsParameters: [['1000000000000000000']],
        callData: ['0xce6298e10000000000000000000000000000000000000000000000000de0b6b3a7640000']
    },
    {
        name: 'wBETH/ETH Exchange Rate',
        decimals: 18,
        chainAlias: 'bsc',
        returnType: 'type-0',
        contractAddress: '0xa2E3356610840701BDf5611a53974510Ae27E2e1',
        implementationAddress: '0xfe928a7d8be9c8cece7e97f0ed5704f4fa2cb42a',
        contractMethods: ['exchangeRate'],
        contractMethodsParameters: [[]],
        callData: ['0x3ba0b9a9']
    },
    {
        name: 'rETH/ETH Exchange Rate',
        decimals: 18,
        chainAlias: 'ethereum',
        returnType: 'type-0',
        contractAddress: '0xae78736cd615f374d3085123a210448e74fc6393',
        contractMethods: ['getExchangeRate'],
        contractMethodsParameters: [[]],
        callData: ['0xe6aa216c']
    },
    {
        name: 'wstETH/stETH Exchange Rate',
        decimals: 18,
        chainAlias: 'ethereum',
        returnType: 'type-0',
        contractAddress: '0x7f39c581f595b53c5cb19bd0b3f8da6c935e2ca0',
        contractMethods: ['stEthPerToken'],
        contractMethodsParameters: [[]],
        callData: ['0x035faf82']
    },
    {
        name: 'cbETH/ETH Exchange Rate',
        decimals: 18,
        chainAlias: 'ethereum',
        returnType: 'type-0',
        contractAddress: '0xbe9895146f7af43049ca1c1ae358b0541ea49704',
        implementationAddress: '0x31724ca0c982a31fbb5c57f4217ab585271fc9a5',
        contractMethods: ['exchangeRate'],
        contractMethodsParameters: [[]],
        callData: ['0x3ba0b9a9']
    },
    {
        name: 'swETH/ETH Exchange Rate',
        decimals: 18,
        chainAlias: 'ethereum',
        returnType: 'type-0',
        contractAddress: '0xf951E335afb289353dc249e82926178EaC7DEd78',
        implementationAddress: '0xdda46bf18eeb3e06e2f12975a3a184e40581a72f',
        contractMethods: ['getRate'],
        contractMethodsParameters: [[]],
        callData: ['0x679aefce']
    },
    {
        name: 'sfrxETH/frxETH Exchange Rate',
        decimals: 18,
        chainAlias: 'ethereum',
        returnType: 'type-0',
        contractAddress: '0xac3e018457b222d93114458476f3e3416abbe38f',
        contractMethods: ['pricePerShare'],
        contractMethodsParameters: [[]],
        callData: ['0x99530b06']
    },
    {
        name: 'mETH/ETH Exchange Rate',
        decimals: 18,
        chainAlias: 'ethereum',
        returnType: 'type-0',
        contractAddress: '0xe3cBd06D7dadB3F4e6557bAb7EdD924CD1489E8f',
        implementationAddress: '0xdecacc56fc347274d3df2b709602632845611d39',
        contractMethods: ['mETHToETH'],
        contractMethodsParameters: [['1000000000000000000']],
        callData: ['0x5890c11c0000000000000000000000000000000000000000000000000de0b6b3a7640000']
    },
    {
        name: 'uniETH/ETH Exchange Rate',
        decimals: 18,
        chainAlias: 'ethereum',
        returnType: 'type-0',
        contractAddress: '0x4beFa2aA9c305238AA3E0b5D17eB20C045269E9d',
        implementationAddress: '0x413c36f939eef24e9aca2f3e708b93ebba4d1247',
        contractMethods: ['exchangeRatio'],
        contractMethodsParameters: [[]],
        callData: ['0x4006ccc5']
    },
    {
        name: 'weETH/ETH Exchange Rate',
        decimals: 18,
        chainAlias: 'ethereum',
        returnType: 'type-0',
        contractAddress: '0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee',
        implementationAddress: '0xe629ee84c1bd9ea9c677d2d5391919fcf5e7d5d9',
        contractMethods: ['getRate'],
        contractMethodsParameters: [[]],
        callData: ['0x679aefce']
    },
    {
        name: 'STONE/ETH Exchange Rate',
        decimals: 18,
        chainAlias: 'ethereum',
        returnType: 'type-0',
        contractAddress: '0x7122985656e38BDC0302Db86685bb972b145bD3C',
        contractMethods: ['tokenPrice'],
        contractMethodsParameters: [[]],
        callData: ['0x7ff9b596']
    },
    {
        name: 'rsETH/ETH Exchange Rate',
        decimals: 18,
        chainAlias: 'ethereum',
        returnType: 'type-0',
        contractAddress: '0x349A73444b1a310BAe67ef67973022020d70020d',
        implementationAddress: '0xa88845af0d087ce8cf2f6d7d7a674154b21f73a5',
        contractMethods: ['rsETHPrice'],
        contractMethodsParameters: [[]],
        callData: ['0xb4b46434']
    },
    {
        name: 'rswETH/ETH Exchange Rate',
        decimals: 18,
        chainAlias: 'ethereum',
        returnType: 'type-0',
        contractAddress: '0xFAe103DC9cf190eD75350761e95403b7b8aFa6c0',
        implementationAddress: '0xcd284a617b4ed7697c2e455d95049c7fc538785c',
        contractMethods: ['rswETHToETHRate'],
        contractMethodsParameters: [[]],
        callData: ['0xa7b9544e']
    },
    {
        name: 'apxETH/pxETH Exchange Rate',
        decimals: 18,
        chainAlias: 'ethereum',
        returnType: 'type-0',
        contractAddress: '0x9Ba021B0a9b958B5E75cE9f6dff97C7eE52cb3E6',
        contractMethods: ['assetsPerShare'],
        contractMethodsParameters: [[]],
        callData: ['0x35d16e17']
    },
    {
        name: 'ezETH/ETH Exchange Rate',
        decimals: 18,
        chainAlias: 'ethereum',
        returnType: 'type-0',
        contractAddress: '0x387dBc0fB00b26fb085aa658527D5BE98302c84C',
        implementationAddress: '0x9284ceff248315377e782df0666ee9832e119508',
        contractMethods: ['getRate'],
        contractMethodsParameters: [[]],
        callData: ['0x679aefce']
    },
    {
        name: 'sDAI/DAI Exchange Rate',
        decimals: 18,
        chainAlias: 'ethereum',
        returnType: 'type-0',
        contractAddress: '0x83F20F44975D03b1b09e64809B757c47f942BEeA',
        contractMethods: ['convertToAssets'],
        contractMethodsParameters: [['1000000000000000000']],
        callData: ['0x07a2d13a0000000000000000000000000000000000000000000000000de0b6b3a7640000']
    },
    {
        name: 'sUSDe/USDe Exchange Rate',
        decimals: 18,
        chainAlias: 'ethereum',
        returnType: 'type-0',
        contractAddress: '0x9D39A5DE30e57443BfF2A8307A4256c8797A3497',
        contractMethods: ['convertToAssets'],
        contractMethodsParameters: [['1000000000000000000']],
        callData: ['0x07a2d13a0000000000000000000000000000000000000000000000000de0b6b3a7640000']
    },
    {
        name: 'pufETH/stETH Exchange Rate',
        decimals: 18,
        chainAlias: 'ethereum',
        returnType: 'type-0',
        contractAddress: '0xD9A442856C234a39a81a089C06451EBAa4306a72',
        implementationAddress: '0x39ca0a6438b6050ea2ac909ba65920c7451305c1',
        contractMethods: ['convertToAssets'],
        contractMethodsParameters: [['1000000000000000000']],
        callData: ['0x07a2d13a0000000000000000000000000000000000000000000000000de0b6b3a7640000']
    },
    {
        name: 'stTAO/TAO Exchange Rate',
        decimals: 18,
        chainAlias: 'ethereum',
        returnType: 'type-0',
        contractAddress: '0xB60acD2057067DC9ed8c083f5aa227a244044fD6',
        implementationAddress: '0x52a139dDe6c5dF3B79A40FB051B954B3A52fBaA0',
        contractMethods: ['getWTAOByWstTAOAfterFee'],
        contractMethodsParameters: [['1000000000000000000']],
        callData: ['0x72a1f67d0000000000000000000000000000000000000000000000000de0b6b3a7640000']
    },
    {
        name: 'sFRAX/FRAX Exchange Rate',
        decimals: 18,
        chainAlias: 'ethereum',
        returnType: 'type-0',
        contractAddress: '0xa663b02cf0a4b149d2ad41910cb81e23e1c41c32',
        contractMethods: ['pricePerShare'],
        contractMethodsParameters: [[]],
        callData: ['0x99530b06']
    },
    {
        name: 'MATICx/MATIC Exchange Rate',
        decimals: 18,
        chainAlias: 'ethereum',
        returnType: 'type-1',
        contractAddress: '0xf03a7eb46d01d9ecaa104558c732cf82f6b6b645',
        implementationAddress: '0x5a78f4bd60c92fcbbf1c941bc1136491d2896b35',
        contractMethods: ['convertMaticXToMatic'],
        contractMethodsParameters: [['1000000000000000000']],
        callData: ['0x75a85ef50000000000000000000000000000000000000000000000000de0b6b3a7640000']
    },
    {
        name: 'ankrETH/ETH Exchange Rate',
        decimals: 18,
        chainAlias: 'ethereum',
        returnType: 'type-0',
        contractAddress: '0x00F8e64a8651E3479A0B20F46b1D462Fe29D6aBc',
        contractMethods: ['getRate'],
        contractMethodsParameters: [[]],
        callData: ['0x679aefce']
    },
    {
        name: 'agETH/rsETH Exchange Rate',
        decimals: 18,
        chainAlias: 'ethereum',
        returnType: 'type-0',
        contractAddress: '0xe1b4d34e8754600962cd944b535180bd758e6c2e',
        implementationAddress: '0x01630191978b6ade4e959054dcd4863a503ecce9',
        contractMethods: ['convertToAssets'],
        contractMethodsParameters: [['1000000000000000000']],
        callData: ['0x07a2d13a0000000000000000000000000000000000000000000000000de0b6b3a7640000']
    },
    {
        name: 'eBTC/WBTC Exchange Rate',
        decimals: 8,
        chainAlias: 'ethereum',
        returnType: 'type-0',
        contractAddress: '0x1b293DC39F94157fA0D1D36d7e0090C8B8B8c13F',
        contractMethods: ['getRate'],
        contractMethodsParameters: [[]],
        callData: ['0x679aefce']
    },
    {
        name: 'cmETH/mETH Exchange Rate',
        decimals: 18,
        chainAlias: 'ethereum',
        returnType: 'type-0',
        contractAddress: '0x6049Bd892F14669a4466e46981ecEd75D610a2eC',
        contractMethods: ['getRate'],
        contractMethodsParameters: [[]],
        callData: ['0x679aefce']
    },
    {
        name: 'LsETH/ETH Exchange Rate',
        decimals: 18,
        chainAlias: 'ethereum',
        returnType: 'type-0',
        contractAddress: '0x8c1bed5b9a0928467c9b1341da1d7bd5e10b6549',
        implementationAddress: '0x48d93d8c45fb25125f13cdd40529bbeaa97a6565',
        contractMethods: ['underlyingBalanceFromShares'],
        contractMethodsParameters: [['1000000000000000000']],
        callData: ['0xf79c3f020000000000000000000000000000000000000000000000000de0b6b3a7640000']
    },
    {
        name: 'yUSD/USD Exchange Rate',
        decimals: 18,
        chainAlias: 'ethereum',
        returnType: 'type-0',
        contractAddress: '0x19Ebd191f7A24ECE672ba13A302212b5eF7F35cb',
        implementationAddress: '0x28cDfc8C2b8Fc8388f26bAc1B0876802708B9F23',
        contractMethods: ['exchangeRateScaled'],
        contractMethodsParameters: [[]],
        callData: ['0xd14f3da1']
    },
    {
        name: 'scrvUSD/crvUSD Exchange Rate',
        decimals: 18,
        chainAlias: 'ethereum',
        returnType: 'type-0',
        contractAddress: '0x0655977feb2f289a4ab78af67bab0d17aab84367',
        contractMethods: ['pricePerShare'],
        contractMethodsParameters: [[]],
        callData: ['0x99530b06']
    },
    {
        name: 'sUSDS/USDS Exchange Rate',
        decimals: 18,
        chainAlias: 'ethereum',
        returnType: 'type-0',
        contractAddress: '0xa3931d71877c0e7a3148cb7eb4463524fec27fbd',
        implementationAddress: '0x4e7991e5c547ce825bdeb665ee14a3274f9f61e0',
        contractMethods: ['convertToAssets'],
        contractMethodsParameters: [['1000000000000000000']],
        callData: ['0x07a2d13a0000000000000000000000000000000000000000000000000de0b6b3a7640000']
    },
    {
        name: 'ysUSDC/USDC Exchange Rate',
        decimals: 18,
        chainAlias: 'ethereum',
        returnType: 'type-0',
        contractAddress: '0xF7DE3c70F2db39a188A81052d2f3C8e3e217822a',
        implementationAddress: '0xbb51273d6c746910c7c06fe718f30c936170fed0',
        contractMethods: ['convertToAssets'],
        contractMethodsParameters: [['1000000000000000000']],
        callData: ['0x07a2d13a0000000000000000000000000000000000000000000000000de0b6b3a7640000']
    },
    {
        name: 'sfrxUSD/frxUSD Exchange Rate',
        decimals: 18,
        chainAlias: 'ethereum',
        returnType: 'type-0',
        contractAddress: '0xcf62F905562626CfcDD2261162a51fd02Fc9c5b6',
        implementationAddress: '0x4486c140aFABe2B4ee98CB2a67A0E711eb063baF',
        contractMethods: ['pricePerShare'],
        contractMethodsParameters: [[]],
        callData: ['0x99530b06']
    },
    {
        name: 'osETH/ETH Exchange Rate',
        decimals: 18,
        chainAlias: 'ethereum',
        returnType: 'type-0',
        contractAddress: '0x8023518b2192FB5384DAdc596765B3dD1cdFe471',
        contractMethods: ['getRate'],
        contractMethodsParameters: [[]],
        callData: ['0x679aefce']
    },
    {
        name: 'wOS/OS Exchange Rate',
        decimals: 18,
        chainAlias: 'sonic',
        returnType: 'type-0',
        contractAddress: '0x9F0dF7799f6FDAd409300080cfF680f5A23df4b1',
        implementationAddress: '0x1CCB48fb244fE1f6eB0d1C5Fbd839DB78c6C5805',
        contractMethods: ['convertToAssets'],
        contractMethodsParameters: [['1000000000000000000']],
        callData: ['0x07a2d13a0000000000000000000000000000000000000000000000000de0b6b3a7640000']
    },
    {
        name: 'syrupUSDC/USDC Exchange Rate',
        decimals: 18,
        chainAlias: 'ethereum',
        returnType: 'type-0',
        contractAddress: '0x80ac24aa929eaf5013f6436cda2a7ba190f5cc0b',
        contractMethods: ['convertToAssets'],
        contractMethodsParameters: [['1000000000000000000']],
        callData: ['0x07a2d13a0000000000000000000000000000000000000000000000000de0b6b3a7640000']
    },
    {
        name: 'wsrUSD/rUSD Exchange Rate',
        decimals: 18,
        chainAlias: 'ethereum',
        returnType: 'type-0',
        contractAddress: '0xd3fD63209FA2D55B07A0f6db36C2f43900be3094',
        contractMethods: ['convertToAssets'],
        contractMethodsParameters: [['1000000000000000000']],
        callData: ['0x07a2d13a0000000000000000000000000000000000000000000000000de0b6b3a7640000']
    },
    {
        name: 'tETH/wstETH Exchange Rate',
        decimals: 18,
        chainAlias: 'ethereum',
        returnType: 'type-0',
        contractAddress: '0xd11c452fc99cf405034ee446803b6f6c1f6d5ed8',
        implementationAddress: '0xD1A622566F277AA76c3C47A30469432AAec95E38',
        contractMethods: ['convertToAssets'],
        contractMethodsParameters: [['1000000000000000000']],
        callData: ['0x07a2d13a0000000000000000000000000000000000000000000000000de0b6b3a7640000']
    },
    {
        name: 'siUSD/iUSD Exchange Rate',
        decimals: 18,
        chainAlias: 'ethereum',
        returnType: 'type-0',
        contractAddress: '0x43ddb6634416bc232566d82Ce7F21bD127cd6bC2',
        contractMethods: ['price'],
        contractMethodsParameters: [[]],
        callData: ['0xa035b1fe']
    }
];
//# sourceMappingURL=catalog.js.map